import type { ReactNode } from "react";
import { StyledActionsRow, StyledMainContent, StyledView } from "./styles";

type Props = {
    children: NonNullable<ReactNode>;
    actions: NonNullable<ReactNode>;
};

const NoContentView = ({ children, actions }: Props) => {
    return (
        <StyledView data-automation="no-content-view">
            <StyledMainContent>{children}</StyledMainContent>
            <StyledActionsRow>{actions}</StyledActionsRow>
        </StyledView>
    );
};

export default NoContentView;
